import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import App from './App';
import './index.css';

/**
 * Refetch when the tab regains focus. This is not a preference, it is a bug fix.
 *
 * With refetchOnWindowFocus off, a tab left open keeps showing whatever it fetched
 * when it was opened, forever, with nothing on screen to say the data is old. On
 * 2026-08-04 the Counter Validation page sat on a tab from lunchtime and reported
 * 311 people for a day that actually had 1,685. The numbers were internally
 * consistent, which is what made it convincing: it was a correct answer to a
 * question asked hours earlier.
 *
 * Steven's instruction (2026-08-05): users must never have to clear anything or
 * take a manual step to see current data. So the app refreshes itself.
 *
 * staleTime keeps this cheap. A refocus inside 30 seconds reuses the cache, so
 * alt-tabbing does not turn into a request storm; only a genuinely stale view
 * refetches.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: true, refetchOnReconnect: true },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
